import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import logger from './logging'
import moment from 'vue-moment'
import VeeValidate from 'vee-validate'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import './plugins/vuetify'
Vue.config.productionTip = false

Vue.use(VeeValidate);
Vue.prototype.$logger = logger;
Vue.use(moment);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
